import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class ProductSkuComponent extends Component {
  requiredRefs = ['skuContainer', 'sku', 'variantData'];

  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
    this.renderFromCurrentVariant();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  get variantMap() {
    try {
      return JSON.parse(this.refs.variantData?.textContent || '{}');
    } catch {
      return {};
    }
  }

  getCurrentVariantId() {
    const productRoot = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card') || document;
    const variantInput = productRoot.querySelector('form[action*="/cart/add"] input[name="id"]');
    return variantInput?.value || this.dataset.initialVariantId || '';
  }

  setText(sku, ean) {
    const cleanSku = (sku || '').trim();
    const cleanEan = (ean || '').trim();

    const lines = [];

    if (cleanSku) {
      lines.push(`No. ${cleanSku}`);
    }

    if (cleanEan) {
      lines.push(`EAN ${cleanEan}`);
    }

    const text = lines.join('\n');

    this.refs.sku.style.display = 'block';
    this.refs.sku.style.whiteSpace = 'pre-line';
    this.refs.sku.textContent = text;

    if (text) {
      this.style.display = 'block';
      this.refs.skuContainer.style.display = '';
    } else {
      this.style.display = 'none';
      this.refs.skuContainer.style.display = 'none';
    }
  }

  renderFromCurrentVariant() {
    const variantId = this.getCurrentVariantId();
    const variant = this.variantMap[variantId];

    if (variant) {
      this.setText(variant.sku, variant.ean);
    }
  }

  updateSku = (event) => {
    if (event.detail.data?.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }

    if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const html = event.detail.data?.html;
    if (html) {
      const newSkuComponent = html.querySelector('product-sku-component');
      const newVariantData = newSkuComponent?.querySelector('[ref="variantData"]')?.textContent || '{}';
      const newVariantId =
        html.querySelector('form[action*="/cart/add"] input[name="id"]')?.value ||
        this.getCurrentVariantId();

      try {
        const newVariantMap = JSON.parse(newVariantData);
        const variant = newVariantMap[newVariantId];

        if (variant) {
          this.refs.variantData.textContent = newVariantData;
          this.setText(variant.sku, variant.ean);
          return;
        }
      } catch {
      }
    }

    this.renderFromCurrentVariant();
  };
}

if (!customElements.get('product-sku-component')) {
  customElements.define('product-sku-component', ProductSkuComponent);
}